import {
  createStore,
  Store,
  useStore as baseUseStore,
  Commit,
  MutationTree,
  GetterTree,
  ActionTree,
} from "vuex";
import { RootState } from "@/types/root-type";
import { store_key } from "@/symbols";
import { user_module } from "./modules/user-module";
import { withholding_module } from "./modules/withholding-module";

const state: RootState = {
  loading: false,
};

const mutations: MutationTree<RootState> = {
  set_loading: (state: RootState, payload: boolean): void => {
    state.loading = payload;
  },
};

const getters: GetterTree<RootState, RootState> = {
  loading: (state: RootState): boolean => state.loading,
};

const actions: ActionTree<RootState, RootState> = {
  update_loading: ({ commit }: { commit: Commit }, payload: boolean): void => {
    commit("set_loading", payload);
  },
};

const modules = {
  user_module,
  withholding_module,
};

export const store = createStore<RootState>({
  state,
  mutations,
  getters,
  actions,
  modules,
});

export function useStore(): Store<RootState> {
  return baseUseStore(store_key);
}
